import { InitiatePaymentResponse, Payment, PaymentStatus } from "@/types/api/payment";
import { apiClient } from "@/utils/axios";

export default {
  initiate: async (orderId: string): Promise<{ id: string; paymentMethodData: Record<string, string> }> => {
    const { data } = await apiClient.get(`/orders/${orderId}/payment-token`);
    const response = await apiClient.post<InitiatePaymentResponse>("/payments", { paymentMethod: "SWISH", token: data.token });
    return response.data;
  },

  get: async (paymentId: string): Promise<Payment> => {
    const response = await apiClient.get(`/payments/${paymentId}`);
    return response.data;
  },

  cancel: async (paymentId: string): Promise<void> => {
    await apiClient.post(`/payments/${paymentId}/cancel`);
  },
};
